import api from '../REST/api';
import { markUiAction } from '../utils/create-ui-action';

// eslint-disable-next-line import/prefer-default-export
export const fetchProducts = () => (dispatch, getState) => {
  const { products } = getState();
  if (products.length) {
    return Promise.resolve({ value: products });
  }
  return dispatch(
    markUiAction({
      type: fetchProducts.toString(),
      payload: api.getProducts(),
    }),
  );
};

fetchProducts.toString = () => 'products/fetch';
